// extracted by mini-css-extract-plugin
module.exports = {"loader":"BookingTimeInfo_loader__3YBiQ","root":"BookingTimeInfo_root__1rMdO","bookingInfo":"BookingTimeInfo_bookingInfo__Aw5zh","dateSection":"BookingTimeInfo_dateSection__3MsL7"};